import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';

//COMPONENTS
import {Modal, Button, Icon} from '../inspinia'

class ModalSucesso extends React.Component
{
    constructor(props)
    {
        super(props);

        this.handleVoltarClick = this.handleVoltarClick.bind(this);
        this.handleNovaClick   = this.handleNovaClick.bind(this);
    }

    handleVoltarClick()
    {
        this.props.actions.campanha.finalizar().then(() => 
        {
            this.props.history.push(c.DEFAULT_PRIVATE_ROUTE);
        });
    }

    handleNovaClick()
    {
        this.props.actions.campanha.finalizar().then(() => 
        {
            this.props.history.push(c.CAMPAIGN_ROUTE+"/criar");
        });
    }

    render()
    {
        return (                       
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>              
                <img src="assets/images/Image 9.png" alt="" />
                                    
                <h3 className="fs-20 fw-600 text-body">
                    Campanha enviada/agendada com sucesso!
                </h3>

                <p className="fs-16 fw-300 text-body">
                    Agora é só aguardar o envio.
                </p>

                <div className="input-group d-block text-center mt-4">
                    <Button onClick={this.handleVoltarClick} className="btn btn-outline btn-primary mx-1" style={{width: "174px"}}><Icon name="fa-arrow-left" className="mr-2"/> Voltar para o painel</Button>
                    <Button onClick={this.handleNovaClick} className="btn btn-primary mx-1" style={{width: "167.1px"}}>Criar nova campanha</Button>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, campanha: state.campanha };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalSucesso));
